/*
 * @Author: your name
 * @Date: 2020-11-15 15:40:20
 * @LastEditTime: 2021-02-26 09:54:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /dmps-web/src/utils/check.js
 */
const check = {
  email(val) {
    const reg1 = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/ //正则表达式
    return reg1.test(val)
  },

  website(val) {
    const reg = /^(http(s)?:\/\/)\w+[^\s]+(\.[^\s]+){1,}$/
    return reg.test(val)
  },

  numberAndLetter(val) {
    const reg = /^[A-Za-z0-9_]+$/
    return reg.test(val)
  }
}

export default check
